var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('content-aspect-ratio',[_c('video-show',{staticClass:"centered-vertical-element",attrs:{"manifest":_vm.url}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }